import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import propTypes from 'prop-types';

const loadingValueNodeWithCopyButton = (
  <Text
    size="xl"
    sx={{
      width: '75%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: 'white'
    }}
  >
    <Skeleton width="100%" />
  </Text>
);

export default function Field({ title, valueNode, copyButton, loading }) {
  const valueNodeWithCopyButton = (
    <>
      {valueNode}
      {copyButton}
    </>
  );

  return (
    <Stack
      gap="2px"
      minHeight={{ xs: 56, md: 65 }}
    >
      <Text
        color="primary"
        size="lg"
        weight="medium"
      >
        {title}
      </Text>
      <Stack
        direction="row"
        gap="4px"
        position="relative"
      >
        {valueNodeWithCopyButton}
        {loading && loadingValueNodeWithCopyButton}
      </Stack>
    </Stack>
  );
}

Field.propTypes = {
  title: propTypes.string.isRequired,
  valueNode: propTypes.node.isRequired,
  copyButton: propTypes.node.isRequired,
  loading: propTypes.bool
};
